/**
 * ShiftDiffs mixin
 * 
 * Handles text generation of a shifts change log.
 * Requires method HoursType to be defined on the main component.
 * Also requires the FormatsNumbers mixin.
 * Also requires FormatsDates mixin
 */
export default {
    methods: {
        flagDisplay(flag) {
            switch(flag) {
                case 'added': return 'Manually Added';
                case 'deleted': return 'Deleted';
                case 'modified': return 'Modified';
                case 'disputed': return 'Disputed';
                case 'time_excessive': return 'Excessive Visit Length';
                case 'time_expired': return 'Time Expired';
                case 'time_expire': return 'Time Expired';
                default:
                    return '';
            }
        },

        formatCondition(condition) {
            switch (condition) {
                case -1: 
                    return 'Declined';
                case 1:
                    return 'Improved';
                default:
                    return 'No Change';
            }
        },
        
        diffMap(diff) {
            let changes = [];

            for (let key in diff) {
                let old = diff[key]['original'];
                let now = diff[key]['new'];
                switch (key) {
                    case 'client_id':
                        changes.push(['Claimant', `Changed from ${old} to ${now}`]);
                        break;
                    case 'caregiver_id':
                        changes.push(['Provider', `Changed from ${old} to ${now}`]);
                        break;
                    case 'checked_in_method':
                        changes.push(['Checked In Method', `Changed from ${old} to ${now}`]);
                        break;
                    case 'checked_out_method':
                        changes.push(['Checked Out Method', `Changed from ${old} to ${now}`]);
                        break;
                    case 'caregiver_comments':
                        changes.push(['Comments', `Changed from ${old}`]);
                        break;
                    case 'hours_type':
                        old = this.hoursType(old);
                        now = this.hoursType(now);
                        changes.push(['Shift Type', `Changed from ${old} to ${now}`]);
                        break;
                    case 'client_fall':
                        now = now == 1 ? 'Yes' : 'No';
                        changes.push(['Fall', `Changed to ${now}`]);
                        break;
                    case 'client_condition':
                        old = this.formatCondition(old);
                        now = this.formatCondition(now);
                        changes.push(['Condition', `Changed from ${old} to ${now}`]);
                        break;
                    case 'duration':
                        let time = 'Increased ' + this.numberFormat(parseFloat(now) - parseFloat(old)) + ' hours.';
                        if (old > now) {
                            time = 'Decreased ' + this.numberFormat(parseFloat(old) - parseFloat(now)) + ' hours.';
                        }
                        changes.push(['Time', time]);
                        break;
                    case 'caregiver_rate':
                        old = this.moneyFormat(old);
                        now = this.moneyFormat(now);
                        changes.push(['Rate', `Changed from ${old} to ${now}`]);
                        break;
                    case 'hospital_stay':
                        now = now ? 'Yes' : 'No';
                        changes.push(['Hospital Stay', `Changed to ${now}`]);
                        break;
                    case 'still_in_hospital':
                        now = now ? 'Yes' : 'No';
                        changes.push(['Still in Hospital', `Changed to ${now}`]);
                        break;
                    case 'hospital_stay_from_date':
                        old = this.formatDateFromUTC(old);
                        now = this.formatDateFromUTC(now);
                        changes.push(['Hospital Stay From Date', `Changed from ${old} to ${now}`]);
                        break;
                    case 'hospital_stay_to_date':
                        old = this.formatDateFromUTC(old);
                        now = this.formatDateFromUTC(now);
                        changes.push(['Hospital Stay To Date', `Changed from ${old} to ${now}`]);
                        break;
                    case 'activities':
                        if (diff[key]['added'] && diff[key]['added'].length) {
                            changes.push(['Activities Added', diff[key]['added'].join(', ')]);
                        }
                        if (diff[key]['removed'] && diff[key]['removed'].length) {
                            changes.push(['Activities Removed', diff[key]['removed'].join(', ')]);
                        }
                }
            }
            
            return changes;
        },
    },
}